module.exports = __webpack_public_path__ + "media/images/sp/specials/common/present_flower_aqua-9cfbf95f18390e77e5bc812709eb3c9a.jpg";